import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg';

import { useIntl } from 'react-intl';
import { ReactNode } from 'react';
import CCPTheme from 'theme/theme';

export interface AlertModalProps {
  isOpen: boolean;
  handleClose: (e?: {}) => void;
  showIcon?: boolean;
  iconComponent?: ReactNode;
  title?: string;
  description?: string;
  buttonText?: string;
}

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  handleClose,
  showIcon = true,
  iconComponent = <ErrorOutlineIcon htmlColor={CCPTheme.palette.error.main} />,
  title,
  description,
  buttonText,
}) => {
  const { formatMessage } = useIntl();
  return (
    <Dialog open={isOpen} onClose={handleClose} data-test-id='alertModal'>
      <CloseIcon onClick={handleClose} className='dialog-close' />
      <DialogTitle data-test-id='alertModalTitle'>
        {showIcon && <Box className='dialog-icon'>{iconComponent}</Box>}

        <Typography variant='h2' textAlign={showIcon ? 'left' : 'center'}>
          {title
            ? title
            : formatMessage({
                id: 'alert.matching.modal.title',
                defaultMessage: 'User can’t match',
              })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant='subtitle1' textAlign={showIcon ? 'left' : 'center'}>
          {description
            ? description
            : formatMessage({
                id: 'alert.matching.modal.description',
                defaultMessage:
                  'Please enter your details again. Please note that we need your work e-mail address to be able to activate your account.',
              })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant='contained' data-test-id='alertModalCloseButton'>
          {buttonText
            ? buttonText
            : formatMessage({
                id: 'alert.matching.modal.button.close',
                defaultMessage: 'Try again',
              })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertModal;
